<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body">
  <img src="/assets/images/acm/promo/inbox/icon2.webp" height="138" alt="" style="margin-bottom: -2rem" />
  <div class="top-badge">
    <img src="/assets/images/acm/promo/blink-green.webp" height="13" alt="" /> Al-Powered Guest Messaging
  </div>
  <div class="text-center">
    <h4 class="text-dark font-weight-bold" style="font-size: 18px">Stop Losing Bookings to Slow Replies</h4>
    <div style="font-weight: 500; color: #415364">
      <div>Respond faster and turn inquiries into bookings.</div>
    </div>
  </div>
  <div class="text-uppercase text-muted mt-3" style="font-size: 10px; font-weight: 500; letter-spacing: 1.18px">
    What You Can Do with Unified Inbox
  </div>
  <div class="d-flex flex-column w-100" style="gap: 0.5rem; background: white; padding: 2rem; border-radius: 8px">
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/chat.webp" height="32" alt="" />
      <div><span class="font-weight-bold">All Messages Together</span> — every channel in one unified inbox.</div>
    </div>
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/bolt.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Faster Communication</span> — reply instantly, no app switching.</div>
    </div>
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/whatsapp.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Free WhatsApp</span> — auto-enabled in AdvanceCM, no extra cost.</div>
    </div>
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/chat2.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Flexible SMS</span> — credit-based messaging via AdvanceCM App Store.</div>
    </div>
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/mail.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Built-in Email</span> — send & receive directly in the inbox.</div>
    </div>
    <div class="d-flex align-items-center feature-item" style="gap: 1rem">
      <img src="/assets/images/acm/promo/inbox/check.webp" height="32" alt="" />
      <div><span class="font-weight-bold">More Channels Soon</span> — Facebook, Instagram & Gmail coming.</div>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <button
        class="btn btn-secondary bg-dark w-75"
        (click)="goToACM('/inquiries/inbox')"
        style="border-radius: 5px; font-size: 14px"
        matTooltip="Explore 'Unified Inbox' on AdvanceCM"
      >
        <img src="/assets/images/acm/promo/blink.webp" height="13" alt="" />
        Explore Unified Inbox
      </button>
    </div>
  </div>
</div>
